import * as simsonSoundUrlUrl from '../sounds/Simson.mp3'
import * as bellSoundUrlUrl from '../sounds/Bell.mp3'
import * as errorSoundUrlUrl from '../sounds/Error.mp3'

export class SoundsService {
	RING_PAUSE = 30000
	MOTOR_PAUSE = 90000
	_homeStoreId
	_storeIds

	_audioRing
	_playRingPromise
	_audioMotor
	_motorRunPromise
	_audioError
	_audioFailure = false
	_audioPlayed = false

	_audioRingingStarted = false
	_audioRingingInterval = null

	_audioMotorIsRunning = false
	_audioMotorInterval = null

	constructor() {
		this._audioRing = new Audio(bellSoundUrlUrl.default)
		// On ring pause or end
		this._audioRing.addEventListener('pause', () => {
			if (this._playRingPromise) {
				this._playRingPromise = null
				//console.debug('Audio paused or ended.')
				this._audioRing.currentTime = 0
			}
		})
		// On end
		this._audioRing.addEventListener('ended', () => {
			if (this._playRingPromise) {
				this._playRingPromise = null
				//console.debug('Audio ended.')
			}
		})
		this._audioError = new Audio(errorSoundUrlUrl.default)
		this._audioMotor = new Audio(simsonSoundUrlUrl.default)
		// On motor pause or end
		this._audioMotor.addEventListener('pause', () => {
			if (this._motorRunPromise) {
				this._motorRunPromise = null
				//console.debug('Audio paused or ended.')
				this._audioMotor.currentTime = 0
			}
		})
		// On end
		this._audioMotor.addEventListener('ended', () => {
			if (this._motorRunPromise) {
				this._motorRunPromise = null
				//console.debug('Audio ended.')
			}
		})
	}

	startRinging = () => {
		const now = new Date().getTime()
		if (this._audioRingingStarted > now - 5000) return
		this._audioRingingStarted = now
		this._playRingPromise = this._audioRing.play()
		this._handleAudioLifecycle(this._playRingPromise)
		// reschedule
		if (this._audioRingingInterval) {
			clearInterval(this._audioRingingInterval)
		}
		this._audioRingingInterval = setInterval(() => {
			this._playRingPromise = this._audioRing.play()
			this._handleAudioLifecycle(this._playRingPromise)
		}, this.RING_PAUSE)
	}

	stopRinging = () => {
		if (!this._audioRingingStarted) return
		this._audioRingingStarted = null
		// stop interval
		if (this._audioRingingInterval) {
			clearInterval(this._audioRingingInterval)
			this._audioRingingInterval = null
		}
		if (this._playRingPromise) {
			this._playRingPromise
				.then(() => {
					this._audioRing.pause()
					console.debug('Audio sopped')
				})
		}
	}

	playCancelledAlert = () => {
		// Deliberately a distinct error/buzzer sound, so staff don't mistake a
		// cancellation alert for an incoming order (bell) or a delivery (motor).
		this._audioError.currentTime = 0
		this._handleAudioLifecycle(this._audioError.play())
	}

	startMotor = () => {
		if (this._audioMotorIsRunning) return
		this._audioMotorIsRunning = true
		this._motorRunPromise = this._audioMotor.play()
		this._handleAudioLifecycle(this._motorRunPromise)
		// reschedule
		if (this._audioMotorInterval) {
			clearInterval(this._audioMotorInterval)
		}
		this._audioMotorInterval = setInterval(() => {
			this._motorRunPromise = this._audioMotor.play()
			this._handleAudioLifecycle(this._motorRunPromise)
		}, this.MOTOR_PAUSE)
	}

	_handleAudioLifecycle = audioPromise => {
		audioPromise
			.then(() => {
				if (!this._audioPlayed) {
					console.debug('Audio playing...')
					this._audioPlayed = true
				}
			})
			.catch(() => {
				console.error('Audio is still banned ;-(')
				if (!this._audioFailure) {
					this._audioFailure = true
					alert('Please enable audio for this site in the browser settings!')
				}
			})
	}

	stopMotor = () => {
		if (!this._audioMotorIsRunning) return
		this._audioMotorIsRunning = false
		// stop interval
		if (this._audioMotorInterval) {
			clearInterval(this._audioMotorInterval)
			this._audioMotorInterval = null
		}
		if (this._motorRunPromise) {
			this._motorRunPromise
				.then(() => {
					this._audioMotor.pause()
					console.debug('Audio sopped')
					this._audioMotor.currentTime = 0
					this._motorRunPromise = null
				})
		}
	}

}
